import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from './nl.json';
import en from './en.json';
import { store } from '../redux/store';
import { RootState } from '../redux/reducers';
import { normalizeLanguage } from '../types/language';

// Determine dashboard type from environment variable
const dashboardType =
  process.env.REACT_APP_APPLICATION_VERSION === 'BUSINESS' ? 'business' : 'community';

i18n.use(initReactI18next).init({
  fallbackLng: 'nl',
  lng: 'nl',
  debug: false,
  resources: {
    nl: { translation: nl },
    en: { translation: en },
  },
  interpolation: {
    escapeValue: false,
    defaultVariables: {
      dashboard_type: dashboardType,
      dashboard_type_cap: dashboardType.charAt(0).toUpperCase() + dashboardType.slice(1),
    },
  },
});

store.subscribe((): void => {
  const state = store.getState() as RootState;
  const language = normalizeLanguage(state.application.language);
  if (normalizeLanguage(i18n.language) !== language) {
    i18n.changeLanguage(language).catch(() => undefined);
  }
});

export default i18n;
